/* WebComponentFootnote component */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { AbstractComponent } from '@cewe-designsystem/abstract';
import { Component, Element, h, Host, Prop, State } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { isMarketingSession } from '@cewe-designsystem/util_session';

@Component({
  tag: 'cwc-footnote',
  styleUrl: './styles/cwc-footnote.scss',
  shadow: true,
})
export class FootnoteComponent {
  @Element() element: HTMLElement;

  /** disable mapping so always the default slot is visible and never the ekv slot */
  @Prop() disableMapping: boolean = false;

  @State() isEKV: boolean = false;

  /**
   * Called every time the component is connected to the DOM.
   * When the component is first connected, this method is called before componentWillLoad.
   * It is important to note that this method can be called more than once, everytime, the element is attached or moved in the DOM.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec
   */
  connectedCallback() {}

  /**
   * Called every time the component is disconnected from the DOM, i.e., it calls be dispatched more than once
   * DO not confuse with a "onDestroy" kind of event.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec.
   */
  disconnectedCallback() {}

  /**
   * Called once just after the component is first connected to the DOM.
   * A promise can be returned, that can be used to wait for the first render.
   */
  componentWillLoad() {
    this.isEKV = this.disableMapping ? false : isMarketingSession();
  }

  /**
   * Called once just after the component fully loaded and the first render() occurs.
   */
  componentDidLoad() {}

  /**
   * Called before every render().
   * A promise can be returned, that can be used to wait for the upcoming render.
   */
  componentWillRender() {}

  /**
   * Called after every render().
   */
  componentDidRender() {}

  /**
   * Called when the component is about to be updated because some Prop() or State() changed.
   * It is never called during the first render().
   * A promise can be returned, that can be used to wait for the next render.
   */
  componentWillUpdate() {}

  /**
   * Called just after the component updates. It is never called during the first render().
   */
  componentDidUpdate() {}

  /**
   * render
   */
  render() {
    return (
      <Host>
        {!this.isEKV && <slot />}

        {this.isEKV && <slot name="ekv" />}
      </Host>
    );
  }
}

/**
 * mixin abstract functions
 */
Object.setPrototypeOf(FootnoteComponent.prototype, AbstractComponent.prototype);

export interface FootnoteComponent extends AbstractComponent {}
